import React, { useEffect, useState } from "react";
import DiaglogBox from "../DiaglogBox";
import { getProjectDetails } from "../../../utils/API/getprojectDetails";
import toast from "react-hot-toast";
import { LoadingOutlined } from "@ant-design/icons";

const ProjectsRemarks = ({ open, onCancel, projectId }) => {
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState("");
  useEffect(() => {
    fetchRemarks();
  }, [projectId]);

  const fetchRemarks = async () => {
    try {
      setLoading(true);
      // console.log("Project ID", projectId);
      const response = await getProjectDetails(projectId);
      // console.log("Remarks", response);
      setRemarks(response.data.remarks_on_not_verified);
    } catch (error) {
      setLoading(false);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <DiaglogBox width={617} open={open} onCancel={onCancel}>
        <div className="pb-5">
          <h4 className="pt-8 pb-4 w-full text-black text-xl font-bold text-center">
            Your Project is Not verified
          </h4>

          <hr />
          <p className="text-left font-bold text-[sm px-11 py-3">
            Admin's Reason
          </p>
          <div className="px-11">
            {loading ? (
              <div>
                <LoadingOutlined />
              </div>
            ) : (
              <textarea
                className="border border-gray-300 p-2 focus:outline-none rounded-lg"
                style={{ width: "500px", height: "200px", resize: "none" }}
                readOnly
                value={remarks}
              />
            )}
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default ProjectsRemarks;
